﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import PoweredByConsilio from "~base/Components/Composite/PoweredByConsilio";
import {
    NotFoundPageCustomizations,
    NotFoundPageDefaultCustomization,
} from "./Customization";
import { SplashPage } from "~base/Components/Pages/Shared/SplashPage";
import { useAdditionalStyles } from "./Styles";
import { SplashContent } from "~base/Components/Pages/Shared/SplashContent";
import TextBlock from "~base/Components/Primitives/TextBlock";

//-------------------------------------------------------------------------------------
// Props
//-------------------------------------------------------------------------------------

type NotFoundProps = {
    customizations?: NotFoundPageCustomizations;
};

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

export const NotFoundPage: React.FunctionComponent<NotFoundProps> = (
    props: NotFoundProps
) => {
    const customization = {
        ...NotFoundPageDefaultCustomization,
        ...props.customizations,
    };

    const classes = useAdditionalStyles(customization)();

    const headerContent = (
        <TextBlock
            textCode={"VisiFinance.UI.NotFound.Title"}
            cssClass={classes.header}
        />
    );

    return (
        <SplashPage isLoading={false} showSplashScreen={false}>
            <SplashContent header={headerContent} footer={null}>
                <TextBlock
                    size={"Small"}
                    styleType={"Paragraph"}
                    textCode={"VisiFinance.UI.NotFound.Message"}
                />
            </SplashContent>
            <PoweredByConsilio />
        </SplashPage>
    );
};
